/**
 * Rückmeldung eines Hinzufügen-Vorgangs als Toast — die eine Stelle für alle Wege, auf
 * denen eine Karte aus dem Katalog ins Deck geht (Plus der Kachel, Ablage per Drag, Plus
 * der Brücken-Sektion). Ohne sie sagt derselbe Vorgang je nach Weg etwas anderes.
 *
 * `onUndo` gibt es nur dort, wo ein Rückgängig-Stapel läuft (Editor-Fenster). Das
 * Zweitfenster hat keinen — dort bleibt der Toast ohne Knopf, statt einen anzubieten,
 * der ins Leere griffe.
 *
 * @param {(toast: object) => void} pushToast — `push` aus `ui/Toast`
 * @param {{card?: object, duplicate?: boolean}|null} result — Rückgabe des Add-Wegs;
 *   `null` heißt „Fehler bereits gemeldet" und schweigt hier
 * @param {object} [options]
 * @param {string} [options.name] — Kartenname, falls die Antwort keine Karte trägt
 * @param {() => void} [options.onUndo] — Gegenaktion für den „Rückgängig"-Knopf
 */
export function notifyAddResult(pushToast, result, { name, onUndo } = {}) {
  if (!result) return;
  const kartenName = result.card?.name || name || 'Karte';
  if (result.duplicate) {
    pushToast({ tone: 'info', message: `„${kartenName}" ist bereits im Deck` });
    return;
  }
  pushToast({
    tone: 'success',
    message: `„${kartenName}" hinzugefügt`,
    action: onUndo ? { label: 'Rückgängig', onClick: onUndo } : undefined,
  });
}

export default notifyAddResult;
